module.exports = __webpack_public_path__ + "img/naivas_promo_1.a6fdf9f4.png";